import type { XRayDiagnosticCode } from 'pages/Diagnostics/types'
import type { ExamSubtype, OrganSegmentationType } from 'types/exam/types'

/**
 * Catálogo dos eventos enviados ao Mixpanel. Toda propriedade é um enum, número
 * ou booleano: nunca IDs de paciente/exame/diagnóstico nem texto digitado.
 */
export interface AnalyticsEventMap {
  xray_page_viewed: { page: 'list' | 'upload' | 'detail' }
  xray_manual_accepted: Record<string, never>
  xray_list_filter_applied: { filters: XrayListFilterName[] }
  xray_exam_opened: { origin: 'row' | 'new_tab' }
  xray_upload_submitted: XrayUploadProps
  xray_upload_succeeded: XrayUploadProps
  xray_upload_failed: XrayUploadProps
  xray_finding_opened: {
    pathology: XRayDiagnosticCode
    via: 'card' | 'modal_nav'
  }
  xray_finding_disagreed: { pathology: XRayDiagnosticCode; disagreed: boolean }
  xray_subtype_changed: { from: ExamSubtype | null; to: ExamSubtype }
  xray_organs_toggled: {
    organ: OrganSegmentationType | 'all'
    visible: boolean
  }
  xray_report_generated: { success: boolean; duration_since_open_ms: number }
  xray_technical_feedback_sent: Record<string, never>
}

export type AnalyticsEventName = keyof AnalyticsEventMap

export type XrayListFilterName =
  | 'subtypes'
  | 'diagnosticTypes'
  | 'examDate'
  | 'patientId'
  | 'examId'
  | 'diagnosticId'
  | 'status'
  | 'review'
  | 'priority'

export type FileSizeBucket = '<1MB' | '1-5MB' | '5-20MB' | '>20MB'

interface XrayUploadProps {
  size_bucket: FileSizeBucket
  subtype: ExamSubtype
}

const MB = 1024 * 1024

export const fileSizeBucket = (bytes: number): FileSizeBucket => {
  if (bytes < MB) return '<1MB'
  if (bytes < 5 * MB) return '1-5MB'
  if (bytes < 20 * MB) return '5-20MB'
  return '>20MB'
}
